<template>
  <div style="text-align: center">
    <transition name="list" tag="div">
      <div v-if="!canHideFormSubmitSuccess">
        <a-result status="success" sub-title="Oczekuj na dalsze informacje. Strona będzie odświeżała się automatycznie."
                  title="Wniosek został złożony!"/>
      </div>
    </transition>
    <FormDetails @success="success"/>
    <small>Strona odświeża się automatycznie.</small>
    <div style="margin-top: 1em">
      <a-button v-if="isSuccess" type="primary" @click="goTo('Login')">Zaloguj się i ustaw hasło</a-button>
    </div>
  </div>
</template>

<script>
import FormDetails from "@/components/network/FormDetails";

export default {
  data() {
    return {
      isSuccess: false,
      secondsLeft: 5,
      canHideFormSubmitSuccess: false,
    };
  },
  components: {
    FormDetails,
  },
  mounted() {
    if (this.$route.name === 'FormStatus') {
      this.canHideFormSubmitSuccess = true;
    }

    let buttonCountdown = setInterval(() => {
      if (this.secondsLeft > 1) {
        this.secondsLeft -= 1;
      } else {
        this.canHideFormSubmitSuccess = true;
        clearInterval(buttonCountdown);
      }
    }, 1050);
  },
  methods: {
    goTo(page) {
      this.$router.push({name: page});
    },
    success() {
      this.isSuccess = true;
    },
  },
};
</script>

<style scoped>
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease-in-out;
  opacity: 1;
  height: 250px;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  height: 0;
}
</style>